import React, { Component } from "react";
import { Row, Col, Card, Form, CardBody, CardTitle, Container, Button } from "reactstrap";
import Dropzone from "react-dropzone";

// Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import { Link } from "react-router-dom";
import { Stack } from "@mui/material";

class FormUpload extends Component {
  constructor(props) {
    super(props);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.state = {
      breadcrumbItems: [
        { title: "Forms", link: "#" },
        { title: "From Upload", link: "#" },
      ],
      selectedFiles: [],
      imageType: "image/*",
    };
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );

    this.setState({ selectedFiles: files });
  };

  handleDeleteFiles = (id) => {
    const tempFile = this.state.selectedFiles
    const filteredFIle = tempFile && tempFile.length > 0 && tempFile.filter((x, idx) =>
      id !== idx
    )
    this.setState({ selectedFiles: filteredFIle });
  }

  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };


  render() {

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>

            <Breadcrumbs title="FORM FILE UPLOAD" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <CardTitle className="h4">Dropzone</CardTitle>
                    <p className="card-title-desc"> DropzoneJS is an open source library that provides drag’n’drop file uploads with image previews.
                    </p>
                    <Form>
                      <Dropzone
                        accept={this.props.images ? {
                          'image/jpeg': ['.jpeg', '.jpg'],
                          'image/png': ['.png'],
                          'image/webp': ['.webp'],
                          'image/avif': ['.avif']
                        } :
                          {
                            "application/pdf": [],
                            "application/doc": [],
                            "application/docx": [],
                            "application/csv": [],
                          }
                        }
                        multiple={this.props.multiple || false}
                        onDrop={acceptedFiles =>
                          this.handleAcceptedFiles(acceptedFiles)
                        }
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div className="dropzone">
                            <div
                              className="dz-message needsclick"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div className="mb-3">
                                <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                              </div>
                              <h4>Drop files here or click to upload.</h4>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                      <div
                        className="dropzone-previews mt-3"
                        id="file-previews"
                      >
                        {this.state.selectedFiles.map((f, i) => {
                          return (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <Stack flexDirection={"row"} justifyContent={"space-between"}>

                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted fw-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                                <i style={{ cursor: "pointer" }} onClick={(e) => this.handleDeleteFiles(i)} className="ri-close-line"></i>
                              </Stack>

                            </Card>
                          );
                        })}
                      </div>
                    </Form>

                    <div className="text-center mt-4">
                      <Button color="primary" type="button" className="waves-effect waves-light">Send Files</Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment >
    );
  }
}

export default FormUpload;
